import React, { useState } from "react";
import logo from "./logo.svg";
import "./App.css";
import { Box, BackgroundImage } from "@mantine/core";
import Login, { LoginFormValues } from "./pages/Login";
import Chat from "./pages/Chat";
import ChatGPT from "./pages/ChatGPT";

const imageIndex = Math.floor(Math.random() * 15) + 1;

const chatTypes = {
  GROUP: "group",
  CHATGPT: "chatgpt",
};

export interface User extends LoginFormValues {
  id: string;
}

function App() {
  const [isLogin, setIsLogin] = useState<boolean>(() =>
    JSON.parse(window.sessionStorage.getItem("login") || "false")
  );
  const [chatType, setChatType] = useState<string>(
    () => window.sessionStorage.getItem("chatType") || ""
  );

  const [user, setUser] = useState<User>(() =>
    JSON.parse(window.sessionStorage.getItem("user") || "{}")
  );

  return (
    <Box>
      <BackgroundImage src={`/images/backgrounds/background-${imageIndex}.jpg`}>
        <Box
          sx={{
            height: "100vh",
            maxWidth: "600px",
            margin: "auto",
            outline: "1px solid gray",
          }}
        >
          {isLogin ? (
            chatType === chatTypes.GROUP ? (
              <Chat user={user} setUser={setUser} setIsLogin={setIsLogin} />
            ) : (
              chatType === chatTypes.CHATGPT && (
                <ChatGPT setIsLogin={setIsLogin} />
              )
            )
          ) : (
            <Login
              setIsLogin={setIsLogin}
              setUser={setUser}
              setChatType={setChatType}
            />
          )}
        </Box>
      </BackgroundImage>
      <div
        style={{
          position: "fixed",
          right: "10px",
          bottom: "10px",
          color: "#bbb",
        }}
        id='image-copyright'
      >
        ©By
        <a
          href='mailto:ruihua.niu@outlook.com'
          style={{ color: "#bbb", margin: "0 10px" }}
        >
          Ruihua
        </a>
      </div>
    </Box>
  );
}

export default App;
